import { render } from "./CoachProfileView.vue?vue&type=template&id=b8636134&scoped=true"
import script from "./CoachProfileView.vue?vue&type=script&lang=js"
export * from "./CoachProfileView.vue?vue&type=script&lang=js"

import "./CoachProfileView.vue?vue&type=style&index=0&id=b8636134&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8636134"]])

export default __exports__